import * as React from 'react';
import classnames from 'classnames';
import { st, classes } from './Button.st.css';
import { CoreButtonNext as ButtonNext } from '../internal/WixUiCoreComponents/components/CoreButtonNext';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { deprecationLog } from '../../common/deprecationLog';
import { AffixTypes, HoverStyles, PaddingModes } from './types';
const wrapAffix = (icon, type) => (React.createElement("span", { className: classnames(classes[`${type}-icon`], classes.affixIcon) }, icon));
const ButtonComponent = ({ priority, size, fullWidth = false, innerRef, upgrade = false, wrapContent = false, paddingMode = upgrade ? PaddingModes.dynamicPaddings : PaddingModes.legacy, children, className, prefixIcon, suffixIcon, 'data-hook': dataHook, hoverStyle = HoverStyles.colorChange, ...rest }) => {
    const affixes = prefixIcon || suffixIcon
        ? {
            prefixIcon: prefixIcon
                ? wrapAffix(prefixIcon, AffixTypes.prefix)
                : undefined,
            suffixIcon: suffixIcon
                ? wrapAffix(suffixIcon, AffixTypes.suffix)
                : undefined,
        }
        : null;
    const getDataAttributes = (mobile) => ({
        'data-fullwidth': fullWidth,
        'data-mobile': mobile,
    });
    React.useEffect(() => {
        if (!upgrade) {
            deprecationLog('Button', 'The current `Button` component API will be deprecated in a future version. Please use the `upgrade` prop in order to use the new API.');
        }
    }, []);
    return (React.createElement(TPAComponentsConsumer, null, ({ mobile }) => (React.createElement(ButtonNext, { ...getDataAttributes(mobile), ref: innerRef, children: children, "data-hook": dataHook, className: st(classes.root, {
            priority,
            size,
            fullWidth,
            mobile,
            paddingMode,
            wrapContent,
            hoverStyle,
        }, classnames(className, { [classes.hasIcon]: !!affixes })), ...rest, ...affixes }))));
};
export const Button = React.forwardRef((props, ref) => (React.createElement(ButtonComponent, { ...props, innerRef: ref })));
//# sourceMappingURL=Button.js.map